"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var isNumber_1 = tslib_1.__importDefault(require("./isNumber"));
var isString_1 = tslib_1.__importDefault(require("./isString"));
function sync(a, b) {
    if ((0, isNumber_1.default)(a) && (0, isNumber_1.default)(b)) {
        return a + b;
    }
    if ((0, isString_1.default)(a) && (0, isString_1.default)(b)) {
        return a + b;
    }
    throw new TypeError("'a' or 'b' must be type of number or string");
}
function async(a, b) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = sync;
                    return [4 /*yield*/, a];
                case 1:
                    _b = [_c.sent()];
                    return [4 /*yield*/, b];
                case 2: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function add(a, b) {
    if (b === undefined) {
        return function (b) {
            return add(a, b);
        };
    }
    if ((0, utils_1.isPromise)(a) || (0, utils_1.isPromise)(b)) {
        return async(Promise.resolve(a), Promise.resolve(b));
    }
    return sync(a, b);
}
exports.default = add;
//# sourceMappingURL=add.js.map